import { render, staticRenderFns } from "./purchase-detail.vue?vue&type=template&id=17fe1e6d"
import script from "./purchase-detail.vue?vue&type=script&lang=js"
export * from "./purchase-detail.vue?vue&type=script&lang=js"
import style0 from "./purchase-detail.vue?vue&type=style&index=0&id=17fe1e6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports